import { Button, Grid, MenuItem, TextField } from "@mui/material";
import { format } from "date-fns";
import React, { useState } from "react";
import CustomDateFilter from "../../../../components/CustomDateFilter";

export default function DashboardFilter({
  setPeriodo,
  setTipoPedido,
  periodo,
  tipoPedido,
}) {
  const [filtro, setFiltro] = useState({
    periodo: periodo,
    tipoPedido: tipoPedido,
  });

  function handleChangeTipoPedido(event) {
    let name = event.target.name;
    let value = event.target.value;

    setFiltro({ ...filtro, [name]: value });
  }

  const handleChangePeriodo = (startDate, endDate) => {
    const formatDate = (date) => {
      return `${format(date, "yyyy-MM-dd")} 00:00:00`;
    };

    const periodo = {
      dataInicial: formatDate(startDate),
      dataFinal: formatDate(endDate),
    };

    setFiltro({ ...filtro, periodo });
  };
  const onClickBuscar = () => {
    setPeriodo(filtro.periodo);
    setTipoPedido(filtro.tipoPedido);
  };

  return (
    <Grid container spacing={2} alignItems="flex-start">
      <Grid
        size={{
          xs: 12,
          md: 4,
        }}
      >
        <CustomDateFilter onChange={handleChangePeriodo} />
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 3,
        }}
      >
        <TextField
          size="small"
          variant="outlined"
          select
          label="Tipo do pedido"
          name="tipoPedido"
          fullWidth
          defaultValue="TODOS"
          onChange={(event) => handleChangeTipoPedido(event)}
        >
          <MenuItem key="TODOS" value="TODOS">
            TODOS
          </MenuItem>
          <MenuItem key="DELIVERY" value="DELIVERY">
            DELIVERY
          </MenuItem>
          <MenuItem key="MESA" value="MESA">
            MESA
          </MenuItem>
          <MenuItem key="COMANDA" value="COMANDA">
            COMANDA
          </MenuItem>
          <MenuItem key="SEQUENCIAL" value="SEQUENCIAL">
            SEQUENCIAL
          </MenuItem>
        </TextField>
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 2,
        }}
      >
        <Button
          onClick={onClickBuscar}
          fullWidth
          variant="contained"
          color="primary"
        >
          Buscar
        </Button>
      </Grid>
    </Grid>
  );
}
